module.exports = __webpack_public_path__ + "static/media/sepa.342ed14d.svg";